module.exports = "./img/e11ceffabb6f6f986db19d5aa2b3dc81.png";